export default __webpack_public_path__ + "static/media/CrunchyrollIcon.8a3bbb67.svg";